<div class="charging-operators-page" data-testid="charging-operators-container">
  <app-modal-option-panel>
    <h3 panel-title>{{ panelTitle }}</h3>

    <mat-form-field class="modal-select-field operator-select-field">
      <mat-select disableRipple panelClass="modal-select-panel brand-select-panel"
        data-testid="charging-operators-select"
        [formControl]="operatorSelectCtrl"
        [placeholder]="languageService.languageJSON?.SettingsDialog_TypeOperatorName"
        (selectionChange)="addOperator($event.value)">
        <mat-option>
          <ngx-mat-select-search [formControl]="operatorFilterCtrl"
            [placeholderLabel]="languageService.languageJSON?.Global_Search"
            [noEntriesFoundLabel]="''">
            <div class="mat-select-search-custom-header-content"></div>
            <span ngxMatSelectSearchClear class="mat-select-search-clear-icon">&times;</span>
          </ngx-mat-select-search>
        </mat-option>
        @for (operator of filteredOperators(); track operator.id) {
          <mat-option [attr.data-testid]="'charging-operators-option-' + operator.id" [value]="operator">{{ operator.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedOperators().length > 0) {
      <div class="op-list" data-testid="charging-operators-list">
        @for (operator of selectedOperators(); track operator.id) {
          <div class="op-card" [attr.data-testid]="'charging-operators-item-' + operator.id">
            <span class="op-card__icon" [class.op-card__icon--avoid]="mode === 'avoid'"></span>
            <div class="op-card__text">
              <h4>{{ operator.name }}</h4>
            </div>
            <button class="op-card__remove" type="button" [attr.data-testid]="'charging-operators-remove-btn-' + operator.id" (click)="removeOperator(operator)"
              [attr.aria-label]="languageService.languageJSON?.SettingsDialog_ReenableTitle">
              <img [src]="'assets/icons/dark/ui/deletetrack_icon_white.svg'" alt="delete track" />
            </button>
          </div>
        }
      </div>
    }
  </app-modal-option-panel>

  @if (isLoading()) {
    <div class="op-loader">
      <app-ev-loader></app-ev-loader>
    </div>
  }
</div>
